import { useEffect, useState } from 'react';
import { getPasswordScoreAsync } from '~/utils/passwordStrength';
export function usePasswordStrength(password, userInputs) {
    const [score, setScore] = useState(null);
    useEffect(()=>{
        if (!password) {
            setScore(null);
            return;
        }
        let active = true;
        void getPasswordScoreAsync(password, userInputs).then((result)=>{
            if (active) {
                setScore(result);
            }
        });
        return ()=>{
            active = false;
        };
    }, [
        password,
        userInputs
    ]);
    return score;
}
